import type React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'

const StyledLabel = styled.label`
  font-size: ${theme.typography.md};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`

interface FormLabelProps {
  htmlFor?: string
  children: React.ReactNode
  className?: string
}

export const FormLabel: React.FC<FormLabelProps> = ({ htmlFor, children, className }) => {
  return (
    <StyledLabel htmlFor={htmlFor} className={className}>
      {children}
    </StyledLabel>
  )
}
